import CvOverflowMenu from './CvOverflowMenu.vue';
import CvOverflowMenuItem from './CvOverflowMenuItem.vue';
export { CvOverflowMenu, CvOverflowMenuItem };
export default CvOverflowMenu;
